import { GET_CURRENT_USER_PROFILE_QUERY } from '../../integrations/allkort/graphql/gql/CurrentUserProfileQueries';
import { CurrentUserProfile, CurrentUserProfileResponse } from '../../integrations/allkort/graphql/interface/CurrentUserProfile';
import { useGetCustomer } from './useGetCustomer';

/**
 * Hook for fetching the currently authenticated user's own profile.
 * Uses network-only since profile data can change (e.g. after mutations).
 *
 * Usage:
 * const { userProfile, loading, error } = useGetCurrentUserProfile();
 */
export const useGetCurrentUserProfile = () => {
	const { data, loading, error } = useGetCustomer<CurrentUserProfileResponse>(
		GET_CURRENT_USER_PROFILE_QUERY,
		undefined,
		{ fetchPolicy: 'network-only' }
	);

	const userProfile: CurrentUserProfile | null = data?.currentUserProfile ?? null;

	return { userProfile, loading, error };
};
